import { fetchWrapper } from "api";

export const getStatusCounters = () => fetchWrapper("/misc/statusCounters");
export const getServerTime = () => fetchWrapper("/misc/serverTime");
export const postLogError = body => fetchWrapper("POST", "/misc/logError", body, {});
